const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]:not([aria-disabled="true"])',
    '[role="menuitem"]',
    '[role="tab"]',
    '[role="link"]',
    '[data-keyboard-item]'
].join(',');

export function isElementVisible(element: HTMLElement): boolean {
    if (element.closest('[hidden], [aria-hidden="true"]')) {
        return false;
    }

    const style = window.getComputedStyle(element);

    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
    }

    const rect = element.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0;
}

function isNestedInteractive(element: HTMLElement): boolean {
    const parent = element.parentElement?.closest('a[href], button, [role="button"]');

    return Boolean(parent && parent !== element);
}

export function getNavigationRoot(active: HTMLElement | null): HTMLElement {
    const fromActive = active?.closest(
        '[data-keyboard-trap], [role="dialog"], [role="menu"], .g-modal, .g-popup, .g-select-popup'
    );

    if (fromActive instanceof HTMLElement) {
        return fromActive;
    }

    const openOverlay = document.querySelector<HTMLElement>(
        '[role="dialog"]:not([aria-hidden="true"]), [data-keyboard-trap], .g-modal, .g-popup, .g-select-popup'
    );

    if (openOverlay && isElementVisible(openOverlay)) {
        return openOverlay;
    }

    return document.body;
}

export function getFocusableElements(root: ParentNode = document): HTMLElement[] {
    return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter((element) => {
        if (!isElementVisible(element) || element.hasAttribute('disabled')) {
            return false;
        }

        if (isNestedInteractive(element)) {
            return false;
        }

        return true;
    });
}
